// src/features/users/components/UserWalletCard.tsx
import {
  Card,
  formatPersianNumber,
  formatSolarDate,
  PaginatedList,
} from '../../../app/components/foundation';
import type { UserWallet } from '../types/user.types';

export interface UserWalletCardProps {
  wallet: UserWallet | undefined;
  onCredit?: () => void;
  onDebit?: () => void;
  mutationLoading?: boolean;
  mutationError?: string | null;
}

/**
 * Workspace card: wallet balance plus recent transactions summary.
 * `wallet` is provided by the workspace hook; balance/amount are
 * display strings, same as
 * customers/components/CustomerWalletCard.tsx.
 */
export function UserWalletCard({ wallet, onCredit, onDebit, mutationLoading = false, mutationError }: UserWalletCardProps) {
  return (
    <Card className="vania-user-workspace-card vania-user-profile-full-width-card">
      <h2 className="vania-user-workspace-card-title">کیف پول</h2>

      {wallet === undefined ? <p className="vania-user-workspace-empty">اطلاعات کیف پول در دسترس نیست.</p> : <>
        <p className="vania-user-workspace-wallet-balance" dir="ltr">
          {formatPersianNumber(wallet.balance)} تومان
        </p>
        <div className="vania-user-wallet-actions">
          <button type="button" onClick={onCredit} disabled={mutationLoading}>+ افزایش موجودی</button>
          <button type="button" onClick={onDebit} disabled={mutationLoading}>− کاهش موجودی</button>
        </div>
        {mutationError ? <p className="vania-user-action-error" role="alert">{mutationError}</p> : null}

        <div className="vania-user-profile-data-scroll">
          <PaginatedList
            items={wallet.transactions}
            emptyMessage="تراکنشی ثبت نشده است."
            className="vania-user-profile-wallet-list"
            renderItem={(transaction) => (
              <li key={transaction.id} className="vania-user-profile-wallet-row">
                <span
                  className={`vania-user-workspace-list-primary vania-user-workspace-amount-${transaction.type}`}
                  dir="ltr"
                >
                  {transaction.amount === null
                    ? 'مبلغ در دسترس نیست'
                    : `${formatPersianNumber(transaction.amount)} تومان`}
                </span>
                <span className="vania-user-workspace-list-secondary">{transaction.description}</span>
                <span className="vania-user-workspace-list-secondary" dir="ltr">
                  {formatSolarDate(transaction.date)}
                </span>
              </li>
            )}
          />
        </div>
      </>}
    </Card>
  );
}
